module.exports = __webpack_public_path__ + "285467176f7fe6bb6a9c6873b3dad2cc.woff2";